<template>
    <entrance-page-layout :top-bar="true" v-once>
        <box-content-message>
            <template v-slot:icon>
                <img src="@/assets/gifs/bird.gif"
                     alt="bird"
                     width="111"
                     height="89"
                >
            </template>
            <template v-slot:primaryText>
                <div>You've got mail</div>
            </template>
            <template v-slot:secondaryText>
                <div class="emailText">We just emailed a confirmation link to <br/>
                    <span class="webBodyStrong">{{ email }}</span>
                </div>
            </template>
            <template v-slot:secondaryTextAdditional>
                <div>Click on the link in the email to <br/> activate your account.</div>
            </template>
        </box-content-message>
    </entrance-page-layout>
</template>

<script>
import BoxContentMessage from '@/pages/entrance/components/BoxContentMessageLayout.vue';
import EntrancePageLayout from '@/pages/entrance/components/EntrancePageLayout.vue';

export default {
    name: 'YouGotMailPage',
    components: {
        EntrancePageLayout,
        BoxContentMessage
    },
    computed: {
        email() {
            return this.$route.query.email || 'your mail';
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.V2";
</style>
